"use client"

import dynamic from "next/dynamic"
import { useEffect, useState } from "react"

// The assistant pulls in the AI SDK, zod and a markdown renderer — about
// 400 KB of script — and it was in every marketing page's first load,
// competing with the page itself. It now loads once the browser is idle
// after the page is up, so the listings and the shop pages paint first.
const BoothAssistant = dynamic(() => import("./booth-assistant").then((m) => m.BoothAssistant), { ssr: false })

export function BoothAssistantLazy() {
  const [ready, setReady] = useState(false)
  useEffect(() => {
    const w = window as Window & { requestIdleCallback?: (cb: () => void, o?: { timeout: number }) => number }
    if (w.requestIdleCallback) {
      const id = w.requestIdleCallback(() => setReady(true), { timeout: 4000 })
      return () => (window as Window & { cancelIdleCallback?: (id: number) => void }).cancelIdleCallback?.(id)
    }
    const t = setTimeout(() => setReady(true), 2500)
    return () => clearTimeout(t)
  }, [])
  return ready ? <BoothAssistant /> : null
}
